// extracted by mini-css-extract-plugin
export default {"database_view":"database_database_view__g2R-A","animated_dialog":"database_animated_dialog__L08Z4","moveFromTopLeftToCenter":"database_moveFromTopLeftToCenter__vIkRV"};